<!-- eslint-disable vue/no-template-shadow -->

<template>
  <div>
    <b-sidebar
      id="edit-order-item"
      ref="modal"
      right
      shadow
      width="60%"
      header-class="headerModalToggle"
      centered
      size="xl"
      :title="$t('EditOrderItem') + ' ' + articleNumber"
      hide-footer
      no-close-on-esc
      @close="onCancel"
    >
      <template #title>
        <strong style="color: #101828;">{{ `${$t('EditOrderItem')} ${articleNumber}` }}</strong>
      </template>
      <template
        v-slot:header-close
      >
        <button
          style="color: #98A2B3;padding-left: 0px; padding-right: 0px;height: 60px; "
          class="fa fa-close"
          @click="onCancel"
        />
      </template>
      <div
        style="border: 0px solid gray; padding: 19px;"
      >
        <b-form style="padding:10px">
          <b-form-group
            id="input-group-1"
            :label="`${$t('ArticleNumber')}:`"
            label-for="input-1"
          >
            <b-form-input
              id="input-1"
              v-model="formm.articleNumber"
              aria-describedby="input-1-live-feedback"
            />
            <p
              v-if="formm.articleNumber == null || formm.articleNumber == '' "
              style="color:red"
            >
              {{ $t('This_is_a_required_field_and_must_be_at_least_3_letters') }}
            </p>
          </b-form-group>
          <b-form-group
            id="input-group-1"
            :label="`${$t('Size')}:`"
            label-for="input-1"
          >
            <b-form-input
              id="input-1"
              v-model="formm.size"
              aria-describedby="input-1-live-feedback"
            />
            <b-form-invalid-feedback
              id="input-1-live-feedback"
            >{{ $t('This_is_a_required_field_and_must_be_at_least_3_letters') }}</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group
            id="input-group-9"
            :label="`${$t('PickupDate')}:`"
            label-for="input-9"
          >
            <flat-pickr
              v-model="formm.pickUpDate"
              class="form-control"
              :placeholder="$t('PickUpDate')"
            />
            <!-- :config="config" -->
          </b-form-group>
          <b-form-group
            id="input-group-1"
            :label="`${$t('Price')}:`"
            label-for="input-1"
          >
            <b-form-input
              id="input-1"
              v-model.number="formm.price"
              type="number"
            />
            <b-form-invalid-feedback
              id="input-1-live-feedback"
            >{{ $t('This_is_a_required_field_and_must_be_at_least_3_letters') }}</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group
            id="input-group-1"
            :label="`${$t('Discount')}:`"
            label-for="input-1"
          >
            <div style="display:flex;gap:5px;">
              <b-form-input
                id="input-1"
                v-model.number="formm.discount"
                type="number"
              />
              <b-form-select
                v-model="currency"
                dropup
                required
                :options="currencies"
                :aria-placeholder="$t('SelectOrderType')"
                aria-describedby="input-1-live-feedback"
                class="currency"
              />
            </div>
          </b-form-group>
          <b-form-group
            id="input-group-1"
            :label="`${$t('DiscountedPrice')}:`"
            label-for="input-1"
          >
            <b-form-input
              id="input-1"
              v-model.number="discountedPrice"
              type="number"
            />
          </b-form-group>
          <b-form-group
            id="input-group-1"
            :label="`${$t('paidAmount')}:`"
            label-for="input-1"
          >
            <b-form-input
              id="input-1"
              v-model.number="formm.paidAmount"
              type="number"
            />
            <b-form-invalid-feedback
              id="input-1-live-feedback"
            >{{ $t('This_is_a_required_field_and_must_be_at_least_3_letters') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-form>
      </div>
      <hr>
      <section
        v-if="getEditOrder.bodyMeasurements !== null"
        class="custom-modal__wrapper"
        style="margin-bottom: 20px; flex-direction: column;padding:10px"
      >
        <div
          v-if="client == 'ValdrinSahiti'"
          class="skica-container"
        >
          <b-collapse
            :id="`collapse-${idx}`"
            visible
          >
            <div
              class="front-body"
            >

              <div class="betweenCol">
                <div class="input">
                  <span>{{ $t('toraks') }}</span>
                  <b-form-input
                    v-model="formm.bodyMeasurements.thorax"
                    :placeholder="$t('')"
                    class="toraks1"
                  />
                </div>
                <div class="input">
                  <span>{{ $t('Bust') }}</span>
                  <b-form-input
                    v-model="formm.bodyMeasurements.aroundBust"
                    :placeholder="$t('')"
                    class="rrethiGjoksit1"
                  />
                </div>
                <div class="input">
                  <span>{{ $t('UnderBust') }}</span>
                  <b-form-input
                    v-model="formm.bodyMeasurements.aroundUnderBust"
                    :placeholder="$t('')"
                    class="rrethiNenGjoksit1"
                  />
                </div>
                <div class="input">
                  <span>{{ $t('Abdomen') }}</span>
                  <b-form-input
                    v-model="formm.bodyMeasurements.waist"
                    :placeholder="$t('')"
                    class="beli1"
                  />
                </div>
                <div class="input">
                  <span>{{ $t('Hips') }}</span>
                  <b-form-input
                    v-model="formm.bodyMeasurements.aroundHips"
                    :placeholder="$t('')"
                    class="vithet1"
                  />
                </div>
                <div class="input">
                  <span>{{ $t('BustReduction') }}</span>
                  <b-form-input
                    v-model="formm.bodyMeasurements.aroundLeg"
                    :placeholder="$t('')"
                    class="rrethiKembes1"
                  />
                </div>
                <div class="input">
                  <span>{{ $t('UnderBustReduction') }}</span>
                  <b-form-input
                    v-model="formm.bodyMeasurements.aroundKnee"
                    :placeholder="$t('')"
                    class="rrethiGjurit1"
                  />
                </div>
                <div class="input">
                  <span>{{ $t('FrontBody') }}</span>
                  <b-form-input
                    v-model="formm.bodyMeasurements.ankle"
                    :placeholder="$t('')"
                    class="zoguKembeve1"
                  />
                </div>

              </div>
              <div class="betweenCol">


                <div class="input">
                  <span>{{ $t('BackBody') }}</span>
                  <b-form-input
                    v-model="formm.bodyMeasurements.breastReduction"
                    :placeholder="$t('')"
                    class="reniaGjoksit1"
                  />
                </div>
                <div class="input">
                  <span>{{ $t('Shoulders') }}</span>
                  <b-form-input
                    v-model="formm.bodyMeasurements.chestDistance"
                    :placeholder="$t('')"
                    class="distancaGjoksit1"
                  />
                </div>
                <div class="input">
                  <span>{{ $t('ShouldersSeam') }}</span>
                  <b-form-input
                    v-model="formm.bodyMeasurements.sleeveLength"

                    :placeholder="$t('')"
                    class="distancaGjoksit1"
                  />
                </div>
                <div class="input">
                  <span>{{ $t('Distance') }}</span>
                  <b-form-input
                    v-model="formm.bodyMeasurements.interBust"
                    :placeholder="$t('')"
                    class="nderGjoks1"
                  />
                </div>

                <div class="input">
                  <span>{{ $t('ButtocksReduction') }}</span>
                  <b-form-input
                    v-model="formm.bodyMeasurements.frontBody"
                    :placeholder="$t('')"
                    class="trupiPara1"
                  />
                </div>
                <div class="input">
                  <span>{{ $t('Height') }}</span>
                  <b-form-input
                    v-model="formm.bodyMeasurements.length1"
                    :placeholder="$t('')"
                    class="gjatesia11"
                  />
                </div>
                <div class="input">
                  <span>{{ $t('3QuartersLength') }}</span>
                  <b-form-input
                    v-model="formm.bodyMeasurements.length2"
                    :placeholder="$t('')"
                    class="gjatesia21"
                  />
                </div>
              </div>
              <div class="betweenCol">

                <div class="input">
                  <span>{{ $t('ChanelLength') }}</span>
                  <b-form-input
                    v-model="formm.bodyMeasurements.length3"
                    :placeholder="$t('')"
                    class="gjatesia31"
                  />
                </div>
                <div class="input">
                  <span>{{ $t('MiniLength') }}</span>
                  <b-form-input
                    v-model="formm.bodyMeasurements.length4"
                    :placeholder="$t('')"
                    class="gjatesia41"
                  />
                </div>
                <div class="input">
                  <span>{{ $t('SleeveCircumference') }}</span>
                  <b-form-input
                    v-model="formm.bodyMeasurements.aroundSleeve"
                    :placeholder="$t('')"
                    class="rrethiMenges1"
                  />
                </div>
                <div class="input">
                  <span>{{ $t('SleeveLength') }}</span>
                  <b-form-input
                    v-model="formm.bodyMeasurements.elbow"
                    :placeholder="$t('')"
                    class="brryli1"
                  />
                </div>
                <div class="input">
                  <span>{{ $t('M.3QuartersLength') }}</span>
                  <b-form-input
                    v-model="formm.bodyMeasurements.wrist"
                    :placeholder="$t('')"
                    class="kyçi1"
                  />
                </div>
                <div class="input">
                  <span>{{ $t('ElbowCircumference') }}</span>
                  <b-form-input
                    v-model="formm.bodyMeasurements.aroundNeck"
                    :placeholder="$t('')"
                    class="rrethiQafes1"
                  />
                </div>
                <div class="input">
                  <span>{{ $t('WristCircumference') }}</span>
                  <b-form-input
                    v-model="formm.bodyMeasurements.backBody"
                    :placeholder="$t('')"
                    class="trupiPrapa1"
                  />
                </div>
              </div>
            </div>

          </b-collapse>
        </div>
        <div
          v-else
          class="skica-container"
        >
          <b-collapse
            :id="`collapse`"
            visible
          >
            <div
              class="btn-con"
            >
              <button
                type="button"
                @click="showBody = !showBody"
              >
                {{ $t('FlipBody') }}
              </button>
            </div>
            <!-- v-if="dress.showFrontBody" -->
            <div
              v-if="showBody "
              class="front-body"
            >
              <img
                src="../../../assets/images/front-body.svg"
                alt=""
              >
              <div class="toraks">
                <b-form-input
                  v-model="formm.bodyMeasurements.thorax"
                  :placeholder="$t('toraks')"
                  class="toraks1"
                />
              </div>
              <div class="rrethiGjoksit">
                <b-form-input
                  v-model="formm.bodyMeasurements.aroundBust"
                  :placeholder="$t('rrethiGjoksit')"
                  class="rrethiGjoksit1"
                />
              </div>
              <div class="rrethiNenGjoksit">
                <b-form-input
                  v-model="formm.bodyMeasurements.aroundUnderBust"
                  :placeholder="$t('rrethiNenGjoksit')"
                  class="rrethiNenGjoksit1"
                />
              </div>
              <div class="beli">
                <b-form-input
                  v-model="formm.bodyMeasurements.waist"
                  :placeholder="$t('beli')"
                  class="beli1"
                />
              </div>
              <div class="vithet">
                <b-form-input
                  v-model="formm.bodyMeasurements.aroundHips"
                  :placeholder="$t('RrethiVitheve')"
                  class="vithet1"
                />
              </div>
              <div class="rrethiKembes">
                <b-form-input
                  v-model="formm.bodyMeasurements.aroundLeg"
                  :placeholder="$t('rrethiKembes')"
                  class="rrethiKembes1"
                />
              </div>
              <div class="rrethiGjurit">
                <b-form-input
                  v-model="formm.bodyMeasurements.aroundKnee"
                  :placeholder="$t('rrethiGjurit')"
                  class="rrethiGjurit1"
                />
              </div>
              <div class="zoguKembeve">
                <b-form-input
                  v-model="formm.bodyMeasurements.ankle"
                  :placeholder="$t('zoguKembeve')"
                  class="zoguKembeve1"
                />
              </div>

              <div class="reniaGjoksit">
                <b-form-input
                  v-model="formm.bodyMeasurements.breastReduction"
                  :placeholder="$t('reniaGjoksit')"
                  class="reniaGjoksit1"
                />
              </div>
              <div class="distancaGjoksit">
                <b-form-input
                  v-model="formm.bodyMeasurements.chestDistance"
                  :placeholder="$t('distancaGjoksit')"
                  class="distancaGjoksit1"
                />
              </div>
              <div class="nderGjoks">
                <b-form-input
                  v-model="formm.bodyMeasurements.interBust"
                  :placeholder="$t('nderGjoks')"
                  class="nderGjoks1"
                />
              </div>
              <div class="trupiPara">
                <b-form-input
                  v-model="formm.bodyMeasurements.frontBody"
                  :placeholder="$t('trupiPara')"
                  class="trupiPara1"
                />
              </div>
              <div class="gjatesia1">
                <b-form-input
                  v-model="formm.bodyMeasurements.length1"
                  :placeholder="$t('gjatesia1')"
                  class="gjatesia11"
                />
              </div>
              <div class="gjatesia2">
                <b-form-input
                  v-model="formm.bodyMeasurements.length2"
                  :placeholder="$t('gjatesia2')"
                  class="gjatesia21"
                />
              </div>
              <div class="gjatesia3">
                <b-form-input
                  v-model="formm.bodyMeasurements.length3"
                  :placeholder="$t('gjatesia3')"
                  class="gjatesia31"
                />
              </div>
              <div class="gjatesia4">
                <b-form-input
                  v-model="formm.bodyMeasurements.length4"
                  :placeholder="$t('gjatesia4')"
                  class="gjatesia41"
                />
              </div>
            </div>
            <!-- v-if="!dress.showFrontBody" -->
            <div
              v-if="!showBody"
              class="back-body"
            >
              <img
                src="../../../assets/images/back-body.svg"
                alt=""
              >
              <div class="rrethiMenges">
                <b-form-input
                  v-model="formm.bodyMeasurements.aroundSleeve"
                  :placeholder="$t('rrethiMenges')"
                  class="rrethiMenges1"
                />
              </div>
              <div class="brryli">
                <b-form-input
                  v-model="formm.bodyMeasurements.elbow"
                  :placeholder="$t('brryli')"
                  class="brryli1"
                />
              </div>
              <div class="kyçi">
                <b-form-input
                  v-model="formm.bodyMeasurements.wrist"
                  :placeholder="$t('kyqi')"
                  class="kyçi1"
                />
              </div>
              <div class="rrethiQafes">
                <b-form-input
                  v-model="formm.bodyMeasurements.aroundNeck"
                  :placeholder="$t('rrethiQafes')"
                  class="rrethiQafes1"
                />
              </div>
              <div class="trupiPrapa">
                <b-form-input
                  v-model="formm.bodyMeasurements.backBody"
                  :placeholder="$t('trupiPrapa')"
                  class="trupiPrapa1"
                />
              </div>
              <div class="supet">
                <b-form-input
                  v-model="formm.bodyMeasurements.shoulders"
                  :placeholder="$t('supet')"
                  class="supet1"
                />
              </div>
              <div class="shpina">
                <b-form-input
                  v-model="formm.bodyMeasurements.back"
                  :placeholder="$t('shpina')"
                  class="shpina1"
                />
              </div>
              <div class="reniaVitheve">
                <b-form-input
                  v-model="formm.bodyMeasurements.declineOfTheHips"
                  :placeholder="$t('reniaVitheve')"
                  class="reniaVitheve1"
                />
              </div>
              <div class="gjatesiaMenges">
                <b-form-input
                  v-model="formm.bodyMeasurements.sleeveLength"
                  :placeholder="$t('gjatesiaMenges')"
                  class="gjatesiaMenges1"
                />
              </div>
            </div>
          </b-collapse>
        </div>
      </section>
      <div style="padding:20px">
        <p>
          <span class="text-danger fw-bold">{{ $t('WarningForStockTitle') }}:</span>
          {{ $t('WarningForStockDesc') }}
        </p>
        <div class="">
          <b-button
            v-b-toggle="`lapse-${idx}`"
            class="m-1"
            variant="light"
          >
            <b-icon-arrows-expand />
          </b-button>
          <span style="font-weight: 500">{{ $t('ShowMaterialVariant') }}</span>


          <b-collapse
            :id="`lapse-${idx}`"
            visible
          >
            <p
              v-if="duplicatedMaterials"
              style="color: red; margin: 0;"
            >
              {{ $t('DuplicateMaterial') }}
            </p>
            <div
              class="modal-card__wrapper"
              style="align-items: center"
            >
              <div
                v-for="(item, index) in form"
                :key="index"
                class="modal-card"
              >
                <b-form-group
                  id="input-group-3"
                  :label="`${$t('SelectMaterialType')}:`"
                >
                  <i
                    class="modal-card__remove"
                    @click="removeMaterialItemFromCD(index)"
                  >
                    <b-icon-trash />
                  </i>
                  <div
                    class="flex radio-form"
                    style="display:flex;justify-content: space-between;"
                  >
                    <div style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 10px;">
                      <div class="flex aic">
                        <input
                          :id="`one${index}`"
                          v-model="item.measurementType"
                          type="radio"
                          value="Meter"
                          @click="meter(item)"
                        >
                        <label :for="`one${index}`">{{ $t('Meter') }}</label>
                      </div>
                      <div
                        :id="`one${index}`"
                        class="flex aic"
                        @click="resetPackage(item)"
                      >
                        <input
                          v-model="item.measurementType"
                          type="radio"
                          value="Package"
                        >
                        <label :for="`one${index}`">{{ $t('Package') }}</label>
                      </div>
                      <div
                        :id="`one${index}`"
                        class="flex aic"
                        @click="resetSet(item)"
                      >
                        <input
                          v-model="item.measurementType"
                          type="radio"
                          value="Set"
                        >
                        <label :for="`one${index}`">{{ $t('Set') }}</label>
                      </div>
                      <div
                        :id="`one${index}`"
                        class="flex aic"
                        @click="resetPair(item)"
                      >
                        <input
                          v-model="item.measurementType"
                          type="radio"
                          value="Pair"
                        >
                        <label :for="`one${index}`">{{ $t('Pair') }}</label>
                      </div>
                      <div
                        :id="`one${index}`"
                        class="flex aic"
                        @click="resetVerse(item)"
                      >
                        <input
                          v-model="item.measurementType"
                          type="radio"
                          value="Verse"
                        >
                        <label :for="`one${index}`">{{ $t('Beaded strand') }}</label>
                      </div>
                      <div class="flex aic">
                        <input
                          :id="`two${index}`"
                          v-model="item.measurementType"
                          type="radio"
                          value="Parts"
                          @click="part(item)"
                        >
                        <label :for="`two${index}`">  {{ $t('Part') }}</label>
                      </div>
                    </div>
                    <td>
                      <img
                        v-if="item.name != null && item.name != '' "
                        v-b-tooltip="$t('ClickToViewPhoto')"
                        style="height: 30px; border-radius: 6px;cursor: pointer "
                        src="../../../assets/images/imageicon.svg"
                        alt=""
                        @click.stop="getAllImages(item)"
                      >
                    </td>
                  </div>

                </b-form-group>

                <div class="search-toggle">

                  <p>{{ $t('SearchBy') }}</p>
                  <div>
                    <p
                      :class="{ active2: toggleSearch === 'MaterialName' }"
                      @click="showMaterialName(), toggleSearch = 'MaterialName'"
                    >
                      {{ $t('Name') }}
                    </p>
                    <p
                      :class="{ active2: toggleSearch === 'Description' }"
                      @click="showDescription(), toggleSearch = 'Description'"
                    >
                      {{ $t('Description') }}
                    </p>
                  </div>
                </div>

                <b-form-group
                  id="input-select-1"
                  label-for="select-1"
                >
                  <vue-select
                    v-if="item.measurementType === 'Meter' && toggleSearch === 'Description'"
                    v-model="item.name"
                    :options="getFilterVariantsByCodeLike.length == 0 ? getMaterialsVByMeter : getFilterVariantsByCodeLike"
                    :placeholder="$t('Description')"
                    :reduce="(e) => e"
                    label="materialVariantName"
                    @search="onSearchMDesc"
                    @input="currentStock(item.name.materialVariantId)"
                  >
                    <li
                      slot="list-footer"
                      class="pagination"
                      style="display: flex; width: 100%; justify-content: center;"
                    >
                      <button
                        type="button"
                        :style="
                          pageM == 1
                            ? 'width: 50%; border: none;'
                            : 'width: 50%; border: none; background-color: #242F6E; color: white'
                        "
                        :disabled="pageM == 1"
                        @click="prevMeter"
                      >
                        {{ $t('Prev') }}
                      </button>
                      <button
                        :style="getButtonStyle"
                        type="button"
                        :disabled="selectedMaterialVariant != '' ? pageM == getTotalItemsPages : pageM == getTotalPagesForMVM "
                        @click="nextMeter"
                      >
                        {{ $t('Next') }}
                      </button>
                    </li>
                  </vue-select>
                  <vue-select
                    v-else-if="item.measurementType === 'Meter' && toggleSearch === 'MaterialName'"
                    v-model="item.name"
                    :options="getMaterialVariantColorNameLike.length == 0 ? getMaterialsVByMeter : getMaterialVariantColorNameLike"
                    :placeholder="$t('MaterialVariant')"
                    :reduce="(e) => e"
                    label="materialVariantName"
                    @search="onSearchM"
                    @input="currentStock(item.name.materialVariantId)"
                  >
                    <li
                      slot="list-footer"
                      class="pagination"
                      style="display: flex; width: 100%; justify-content: center;"
                    >
                      <button
                        type="button"
                        :style="
                          pageM == 1
                            ? 'width: 50%; border: none;'
                            : 'width: 50%; border: none; background-color: #242F6E; color: white'
                        "
                        :disabled="pageM == 1"
                        @click="prevMeter"
                      >
                        {{ $t('Prev') }}
                      </button>
                      <button
                        :style="getButtonStyle"
                        type="button"
                        :disabled="selectedMaterialVariant != '' ? pageM == getTotalItemsPages : pageM == getTotalPagesForMVM "
                        @click="nextMeter"
                      >
                        {{ $t('Next') }}
                      </button>
                    </li>
                  </vue-select>
                  <vue-select
                    v-else-if="item.measurementType === 'Package' && toggleSearch === 'MaterialName'"
                    v-model="item.name"
                    :options="getMaterialVariantColorNameLike.length == 0 ? getMaterialsVByPackage : getMaterialVariantColorNameLike"
                    :placeholder="$t('MaterialVariant')"
                    :reduce="(e) => e"
                    label="materialVariantName"
                    @search="onSearchPack"
                    @input="currentStock(item.name.materialVariantId)"
                  >
                    <li
                      slot="list-footer"
                      class="pagination"
                      style="display: flex; width: 100%; justify-content: center;"
                    >
                      <button
                        type="button"
                        :style="
                          pageM == 1
                            ? 'width: 50%; border: none;'
                            : 'width: 50%; border: none; background-color: #242F6E; color: white'
                        "
                        :disabled="pagePackage == 1"
                        @click="prevPackage"
                      >
                        {{ $t('Prev') }}
                      </button>
                      <button
                        :style="getButtonStyle"
                        type="button"
                        :disabled="selectedMaterialVariantPackage != '' ? pagePackage == getTotalItemsPages : pagePackage == getTotalPagesForMVM "
                        @click="nextPackage"
                      >
                        {{ $t('Next') }}
                      </button>
                    </li>
                  </vue-select>
                  <vue-select
                    v-else-if="item.measurementType === 'Package' && toggleSearch === 'Description'"
                    v-model="item.name"
                    :options="getFilterVariantsByCodeLike.length == 0 ? getMaterialsVByPackage : getFilterVariantsByCodeLike"
                    :placeholder="$t('Description')"
                    :reduce="(e) => e"
                    label="materialVariantName"
                    @search="onSearchPackDesc"
                    @input="currentStock(item.name.materialVariantId)"
                  >
                    <li
                      slot="list-footer"
                      class="pagination"
                      style="display: flex; width: 100%; justify-content: center;"
                    >
                      <button
                        type="button"
                        :style="
                          pageM == 1
                            ? 'width: 50%; border: none;'
                            : 'width: 50%; border: none; background-color: #242F6E; color: white'
                        "
                        :disabled="pagePackage == 1"
                        @click="prevPackage"
                      >
                        {{ $t('Prev') }}
                      </button>
                      <button
                        :style="getButtonStyle"
                        type="button"
                        :disabled="selectedMaterialVariantPackage != '' ? pagePackage == getTotalItemsPages : pagePackage == getTotalPagesForMVM "
                        @click="nextPackage"
                      >
                        {{ $t('Next') }}
                      </button>
                    </li>
                  </vue-select>
                  <vue-select
                    v-else-if="item.measurementType === 'Set' && toggleSearch === 'MaterialName'"
                    v-model="item.name"
                    :options="getMaterialVariantColorNameLike.length == 0 ? getMaterialsVBySet : getMaterialVariantColorNameLike"
                    :placeholder="$t('MaterialVariant')"
                    :reduce="(e) => e"
                    label="materialVariantName"
                    @search="onSearchSet"
                    @input="currentStock(item.name.materialVariantId)"
                  >
                    <li
                      slot="list-footer"
                      class="pagination"
                      style="display: flex; width: 100%; justify-content: center;"
                    >
                      <button
                        type="button"
                        :style="
                          pageM == 1
                            ? 'width: 50%; border: none;'
                            : 'width: 50%; border: none; background-color: #242F6E; color: white'
                        "
                        :disabled="pageSet == 1"
                        @click="prevSet"
                      >
                        {{ $t('Prev') }}
                      </button>
                      <button
                        :style="getButtonStyle"
                        type="button"
                        :disabled="selectedMaterialVariantSet != '' ? pageSet == getTotalItemsPages : pageSet == getTotalPagesForMVM "
                        @click="nextSet"
                      >
                        {{ $t('Next') }}
                      </button>
                    </li>
                  </vue-select>
                  <vue-select
                    v-else-if="item.measurementType === 'Set' && toggleSearch === 'Description'"
                    v-model="item.name"
                    :options="getFilterVariantsByCodeLike.length == 0 ? getMaterialsVBySet : getFilterVariantsByCodeLike"
                    :placeholder="$t('Description')"
                    :reduce="(e) => e"
                    label="materialVariantName"
                    @search="onSearchSetDesc"
                    @input="currentStock(item.name.materialVariantId)"
                  >
                    <li
                      slot="list-footer"
                      class="pagination"
                      style="display: flex; width: 100%; justify-content: center;"
                    >
                      <button
                        type="button"
                        :style="
                          pageM == 1
                            ? 'width: 50%; border: none;'
                            : 'width: 50%; border: none; background-color: #242F6E; color: white'
                        "
                        :disabled="pageSet == 1"
                        @click="prevSet"
                      >
                        {{ $t('Prev') }}
                      </button>
                      <button
                        :style="getButtonStyle"
                        type="button"
                        :disabled="selectedMaterialVariantSet != '' ? pageSet == getTotalItemsPages : pageSet == getTotalPagesForMVM "
                        @click="nextSet"
                      >
                        {{ $t('Next') }}
                      </button>
                    </li>
                  </vue-select>
                  <vue-select
                    v-else-if="item.measurementType === 'Pair' && toggleSearch === 'MaterialName'"
                    v-model="item.name"
                    :options="getMaterialVariantColorNameLike.length == 0 ? getMaterialsVByPair : getMaterialVariantColorNameLike"
                    :placeholder="$t('MaterialVariant')"
                    :reduce="(e) => e"
                    label="materialVariantName"
                    @search="onSearchPair"
                    @input="currentStock(item.name.materialVariantId)"
                  >
                    <li
                      slot="list-footer"
                      class="pagination"
                      style="display: flex; width: 100%; justify-content: center;"
                    >
                      <button
                        type="button"
                        :style="
                          pageM == 1
                            ? 'width: 50%; border: none;'
                            : 'width: 50%; border: none; background-color: #242F6E; color: white'
                        "
                        :disabled="pagePair == 1"
                        @click="prevPair"
                      >
                        {{ $t('Prev') }}
                      </button>
                      <button
                        :style="getButtonStyle"
                        type="button"
                        :disabled="selectedMaterialVariantPair != '' ? pagePair == getTotalItemsPages : pagePair == getTotalPagesForMVM "
                        @click="nextPair"
                      >
                        {{ $t('Next') }}
                      </button>
                    </li>
                  </vue-select>
                  <vue-select
                    v-else-if="item.measurementType === 'Pair' && toggleSearch === 'Description'"
                    v-model="item.name"
                    :options="getFilterVariantsByCodeLike.length == 0 ? getMaterialsVByPair : getFilterVariantsByCodeLike"
                    :placeholder="$t('MaterialVariant')"
                    :reduce="(e) => e"
                    label="materialVariantName"
                    @search="onSearchPairDesc"
                    @input="currentStock(item.name.materialVariantId)"
                  >
                    <li
                      slot="list-footer"
                      class="pagination"
                      style="display: flex; width: 100%; justify-content: center;"
                    >
                      <button
                        type="button"
                        :style="
                          pageM == 1
                            ? 'width: 50%; border: none;'
                            : 'width: 50%; border: none; background-color: #242F6E; color: white'
                        "
                        :disabled="pagePair == 1"
                        @click="prevPair"
                      >
                        {{ $t('Prev') }}
                      </button>
                      <button
                        :style="getButtonStyle"
                        type="button"
                        :disabled="selectedMaterialVariantPair != '' ? pagePair == getTotalItemsPages : pagePair == getTotalPagesForMVM "
                        @click="nextPair"
                      >
                        {{ $t('Next') }}
                      </button>
                    </li>
                  </vue-select>
                  <vue-select
                    v-else-if="item.measurementType === 'Verse' && toggleSearch === 'MaterialName'"
                    v-model="item.name"
                    :options="getMaterialVariantColorNameLike.length == 0 ? getMaterialsVByVerse : getMaterialVariantColorNameLike"
                    :placeholder="$t('MaterialVariant')"
                    :reduce="(e) => e"
                    label="materialVariantName"
                    @search="onSearchVerse"
                    @input="currentStock(item.name.materialVariantId)"
                  >
                    <li
                      slot="list-footer"
                      class="pagination"
                      style="display: flex; width: 100%; justify-content: center;"
                    >
                      <button
                        type="button"
                        :style="
                          pageM == 1
                            ? 'width: 50%; border: none;'
                            : 'width: 50%; border: none; background-color: #242F6E; color: white'
                        "
                        :disabled="pageVerse == 1"
                        @click="prevVerse"
                      >
                        {{ $t('Prev') }}
                      </button>
                      <button
                        :style="getButtonStyle"
                        type="button"
                        :disabled="selectedMaterialVariantVerse != '' ? pageVerse == getTotalItemsPages : pageVerse == getTotalPagesForMVM "
                        @click="nextVerse"
                      >
                        {{ $t('Next') }}
                      </button>
                    </li>
                  </vue-select>
                  <vue-select
                    v-else-if="item.measurementType === 'Verse' && toggleSearch === 'Description'"
                    v-model="item.name"
                    :options="getFilterVariantsByCodeLike.length == 0 ? getMaterialsVByVerse : getFilterVariantsByCodeLike"
                    :placeholder="$t('MaterialVariant')"
                    :reduce="(e) => e"
                    label="materialVariantName"
                    @search="onSearchVerseDesc"
                    @input="currentStock(item.name.materialVariantId)"
                  >
                    <li
                      slot="list-footer"
                      class="pagination"
                      style="display: flex; width: 100%; justify-content: center;"
                    >
                      <button
                        type="button"
                        :style="
                          pageM == 1
                            ? 'width: 50%; border: none;'
                            : 'width: 50%; border: none; background-color: #242F6E; color: white'
                        "
                        :disabled="pageVerse == 1"
                        @click="prevVerse"
                      >
                        {{ $t('Prev') }}
                      </button>
                      <button
                        :style="getButtonStyle"
                        type="button"
                        :disabled="selectedMaterialVariantVerse != '' ? pageVerse == getTotalItemsPages : pageVerse == getTotalPagesForMVM "
                        @click="nextVerse"
                      >
                        {{ $t('Next') }}
                      </button>
                    </li>
                  </vue-select>
                  <vue-select
                    v-else-if="item.measurementType === 'Parts' && toggleSearch === 'MaterialName'"
                    v-model="item.name"
                    :options="getMaterialVariantColorNameLike.length == 0 ? getMaterialsVByPart : getMaterialVariantColorNameLike"
                    :placeholder="$t('MaterialVariant')"
                    :reduce="(e) => e"
                    label="materialVariantName"
                    @search="onSearchP"
                    @input="currentStock(item.name.materialVariantId)"
                  >
                    <li
                      slot="list-footer"
                      class="pagination"
                      style="display: flex; width: 100%; justify-content: center"
                    >
                      <button
                        type="button"
                        :style="
                          pageM == 1
                            ? 'width: 50%; border: none;'
                            : 'width: 50%; border: none; background-color: #242F6E; color: white'
                        "
                        :disabled="pageP == 1"
                        @click="prevPart"
                      >
                        {{ $t('Prev') }}
                      </button>
                      <button
                        type="button"
                        :style="getButtonStylePart"
                        :disabled="selectedMaterialVariantPart != '' ? pageP == getTotalItemsPages : pageP == getTotalPagesForMVP "
                        @click="nextPart"
                      >
                        {{ $t('Next') }}
                      </button>
                    </li>
                  </vue-select>
                  <vue-select
                    v-else-if="item.measurementType === 'Parts' && toggleSearch === 'Description'"
                    v-model="item.name"
                    :options="getFilterVariantsByCodeLike.length == 0 ? getMaterialsVByPart : getFilterVariantsByCodeLike"
                    :placeholder="$t('MaterialVariant')"
                    :reduce="(e) => e"
                    label="materialVariantName"
                    @search="onSearchPDesc"
                    @input="currentStock(item.name.materialVariantId)"
                  >
                    <li
                      slot="list-footer"
                      class="pagination"
                      style="display: flex; width: 100%; justify-content: center"
                    >
                      <button
                        type="button"
                        :style="
                          pageM == 1
                            ? 'width: 50%; border: none;'
                            : 'width: 50%; border: none; background-color: #242F6E; color: white'
                        "
                        :disabled="pageP == 1"
                        @click="prevPart"
                      >
                        {{ $t('Prev') }}
                      </button>
                      <button
                        type="button"
                        :style="getButtonStylePart"
                        :disabled="selectedMaterialVariantPart != '' ? pageP == getTotalItemsPages : pageP == getTotalPagesForMVP "
                        @click="nextPart"
                      >
                        {{ $t('Next') }}
                      </button>
                    </li>
                  </vue-select>
                </b-form-group>

                <b-form-group
                  v-if="item.name"
                  :label="`${$t('Price')}:`"
                  style="width: 100%;"
                >
                  <b-input
                    v-if="item.name.pricePerMeter"
                    v-model="item.name.pricePerMeter"
                    type="number"
                    disabled
                  />
                  <b-input
                    v-else-if="!item.name.pricePerMeter"
                    v-model="item.pricePerMeter"
                    type="number"
                    disabled
                  />
                </b-form-group>

                <b-form-group
                  v-if="item.measurementType === 'Meter'"
                  :label="`${$t('Meter')}:`"
                >
                  <b-input
                    v-model="item.length"
                    type="number"
                    @input="valid(item.length,index)"
                  />
                  <p
                    v-if="item.length < 0.0001 "
                    style="color: red;padding-top: 5px;
                margin-bottom: 0px;"
                  >
                    {{ $t('TheValue') }}
                  </p>
                </b-form-group>
                <b-form-group
                  v-else-if="item.measurementType === 'Package'"
                  :label="`${$t('Meter')}:`"
                  style="width: 100%;"
                >
                  <b-input
                    v-model="item.length"
                    type="number"
                    @input="valid(item.length,index)"
                  />
                  <p
                    v-if="item.length < 0.0001 "
                    style="color: red;padding-top: 5px;
                      margin-bottom: 0px;"
                  >
                    {{ $t('TheValue') }}
                  </p>
                </b-form-group>
                <b-form-group
                  v-else-if="item.measurementType === 'Set'"
                  :label="`${$t('Meter')}:`"
                  style="width: 100%;"
                >
                  <b-input
                    v-model="item.length"
                    type="number"
                    @input="valid(item.length,index)"
                  />
                  <p
                    v-if="item.length < 0.0001 "
                    style="color: red;padding-top: 5px;
                      margin-bottom: 0px;"
                  >
                    {{ $t('TheValue') }}
                  </p>
                </b-form-group>
                <b-form-group
                  v-else-if="item.measurementType === 'Pair'"
                  :label="`${$t('Meter')}:`"
                  style="width: 100%;"
                >
                  <b-input
                    v-model="item.length"
                    type="number"
                    @input="valid(item.length,index)"
                  />
                  <p
                    v-if="item.length < 0.0001 "
                    style="color: red;padding-top: 5px;
                      margin-bottom: 0px;"
                  >
                    {{ $t('TheValue') }}
                  </p>
                </b-form-group>
                <b-form-group
                  v-else-if="item.measurementType === 'Verse'"
                  :label="`${$t('Meter')}:`"
                  style="width: 100%;"
                >
                  <b-input
                    v-model="item.length"
                    type="number"
                    @input="valid(item.length,index)"
                  />
                  <p
                    v-if="item.length < 0.0001 "
                    style="color: red;padding-top: 5px;
                      margin-bottom: 0px;"
                  >
                    {{ $t('TheValue') }}
                  </p>
                </b-form-group>
                <b-form-group
                  v-else
                  :label="`${$t('Part')}:`"
                >
                  <b-input
                    v-model="item.quantity"
                    type="number"
                    @input="valid(item.quantity,index)"
                  />
                  <p
                    v-if="item.quantity < 0.0001 "
                    style="color: red;padding-top: 5px;
                margin-bottom: 0px;"
                  >
                    {{ $t('TheValue') }}
                  </p>
                </b-form-group>
                <b-form-group
                  v-if="item.name ? item.name.materialVariantId === clickedMaterialVariantId : false"
                  :label="`${$t('Stock')}:`"
                  style="width: 100%;"
                >
                  <b-form-input
                    v-model="getSavedStock.stockValue"
                    type="number"
                    disabled
                  />
                </b-form-group>
              </div>
              <button
                type="button"
                size="sm"
                class="button"
                style="margin: 20px 0;"
                @click="addNewRowForCD()"
              >
                <p style="margin: 0">
                  + {{ $t('AddMaterial') }}
                </p>
              </button>
            </div>
          </b-collapse>
          <p
            v-if="emptyList"
            style="color: red; margin: 0;"
          >
            {{ $t('EmptyMaterials') }}
          </p>
        </div>
      </div>
      <div class="buttonsEverywhereToggle">
        <b-button
          type="button"
          variant="none"
          class="buttonSubmit"
          @click="onSubmit"
        >
          {{ $t('Submit') }}
        </b-button>
        <b-button
          type="button"
          variant="danger"
          class="buttonCancel"
          style="margin-right: 15px;"
          @click="onCancel"
        >
          {{ $t('Cancel') }}
        </b-button>
      </div>
      <vue-easy-lightbox
        :esc-disabled="false"
        :visible="image.visible"
        :imgs="image.imgs"
        :index="image.index"
        @hide="handleHide"
      />
    </b-sidebar>

  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component';
import { mapGetters, mapActions } from 'vuex'
import VueEasyLightbox from 'vue-easy-lightbox'
import { client } from '../../../domainConfig'



export default {
  components: {
    flatPickr,
    VueEasyLightbox,
  },
  // eslint-disable-next-line vue/require-prop-types
  props: ['articleNumber'],
  data() {
    return {
      currency: '€',
      currencies: ['€', '$', '%'],
      discountedPrice: 0,
      image: {
        zoom: 1,
        imgs: [], // Img Url , string or Array of string
        visible: false,
        index: 0, //
      },
      toggleSearch: 'MaterialName',
      selectedMaterialVariantPackage: '',
      selectedMaterialVariant: '',
      selectedMaterialVariantPart: '',
      selectedMaterialVariantSet: '',
      selectedMaterialVariantPair: '',
      selectedMaterialVariantVerse: '',
      clickedMaterialVariantId: null,
      client: client.clientName,
      showLengthError: false,
      formm: {
        orderItemId: null,
        bodyMeasurements: {
          thorax: null,
          aroundBust: null,
          aroundUnderBust: null,
          waist: null,
          aroundHips: null,
          aroundLeg: null,
          aroundKnee: null,
          aroundNeck: null,
          aroundSleeve: null,
          ankle: null,
          breastReduction: null,
          chestDistance: null,
          interBust: null,
          frontBody: null,
          length1: null,
          length2: null,
          length3: null,
          length4: null,
          elbow: null,
          wrist: null,
          back: null,
          backBody: null,
          shoulders: null,
          declineOfTheHips: null,
          sleeveLength: null,
        },
        discount: 0,
        articleNumber: '',
        size: '',
        pickUpDate: '',
        price: 0,
        paidAmount: 0,
        materialVariantInStoreResponseDtos: [],
      },
      isUndefined: false,
      expand: false,
      index: 0,
      pageM: 1,
      pageP: 1,
      pagePackage: 1,
      pageSet: 1,
      pagePair: 1,
      pageVerse: 1,
      pageSize: 15,
      radio: null,
      idx: 0,
      sizeOptions: [
        {
          size: 'xs',
        },
        {
          size: 's',
        },
        {
          size: 'm',
        },
        {
          size: 'l',
        },
        {
          size: 'xl',
        },
      ],
      showBody: true,
      form: [],
      duplicatedMaterials: false,
      emptyList: false,
    }
  },
  computed: {
    ...mapGetters(['getImagesProduct', 'getSavedStock', 'getMaterialsVByPackage', 'getMaterialsVBySet', 'getMaterialsVByVerse', 'getMaterialsVByPair', 'getTotalItemsPages', 'getMaterialVariantColorNameLike', 'getEditOrder', 'getEditOrderItemMaterialVariant', 'getCurrentPageForMVP', 'getMaterialsVByMeter',
      'getMaterialsVByPart', 'getFilteredMV', 'getTotalPagesForMVP',
      'getTotalPagesForMVM', 'getCurrentPageForMVM', 'getCurrentPageForMVP',
      'getMeasermentsById', 'getFilterVariantsByCodeLike']),
    getButtonStyle() {
      if (this.selectedMaterialVariant !== '') {
        return this.pageM == this.getTotalItemsPages
          ? { width: '50%', border: 'none' }
          : {
            width: '50%', border: 'none', backgroundColor: '#242F6E', color: 'white',
          };
      }
      return this.pageM == this.getTotalPagesForMVM
        ? { width: '50%', border: 'none' }
        : {
          width: '50%', border: 'none', backgroundColor: '#242F6E', color: 'white',
        };
    },
    getButtonStylePart() {
      if (this.selectedMaterialVariantPart !== '') {
        return this.pageM == this.getTotalItemsPages
          ? { width: '50%', border: 'none' }
          : {
            width: '50%', border: 'none', backgroundColor: '#242F6E', color: 'white',
          };
      }
      return this.pageM == this.getTotalPagesForMVP
        ? { width: '50%', border: 'none' }
        : {
          width: '50%', border: 'none', backgroundColor: '#242F6E', color: 'white',
        };
    },
  },
  watch: {
    getEditOrder: {
      handler(newValue) {
        this.formm.bodyMeasurements = newValue.bodyMeasurements;
        this.formm.orderItemId = newValue.orderItemId
        this.formm.paidAmount = newValue.paidAmount
        this.formm.discount = newValue.discount
        this.formm.pickUpDate = newValue.pickUpDate
        this.formm.price = newValue.price
        this.formm.size = newValue.size
        this.formm.articleNumber = newValue.articleNumber
      },
    },
    discountedPrice(newValue) {
      this.handleInputChangePriceDiscount(newValue);
    },
    'formm.price': function (newValue) {
      this.handleInputChangePrice('price', newValue);
    },
    'formm.discount': function (newValue) {
      this.handleInputChangeDiscount('discount', newValue);
    },
    currency(value) {
      if (value) {
        this.formm.discount = 0
        this.discountedPrice = this.formm.price
      }
    },
    form: {
      handler(newValue) {
        const ids = newValue.map((item) => { return item.name.materialVariantName ? item.name.materialVariantName || item.name : item.name });
        const uniqueIds = new Set(ids);
        this.duplicatedMaterials = ids.length !== uniqueIds.size;
        this.emptyList = newValue.length === 0;
      },
      deep: true,
    },
    getEditOrderItemMaterialVariant() {
      this.fillForm()
    },
  },
  mounted() {
    // console.log('articlee', this.getEditOrder.articleNumber)
    // this.formm.bodyMeasurements = this.getEditOrder.bodyMeasurements;
    // this.formm.articleNumber = this.getEditOrder.articleNumber
    // this.formm.materialVariantInStoreResponseDtos = this.getEditOrderItemMaterialVariant

    // this.getEditOrderItemMaterialVariant.materialVariantId = this.getEditOrderItemMaterialVariant.name.materialVariantId
    // this.getEditOrderItemMaterialVariant.name = this.getEditOrderItemMaterialVariant.name.materialVariantName
  },
  methods: {
    ...mapActions(['getImagesByMaterialVariantId', 'currentStockByVariant',
      'resetAllFiltered', 'filterVariantByColor', 'getMaterialVariantsToMDCPagination',
      'edit_OrderItem', 'getMaterialVariantsToMDCPagination', 'testResetMV',
      'loadMaterialVaraintsCategoryNameLike', 'filterVariantByCode']),
    handleInputChangePrice(field, newValue) {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.timeoutId = setTimeout(() => {
        if (newValue < 0 || newValue === '') {
          this.formm[field] = 0;
        }
        if (newValue < this.formm.discount) {
          this.formm.discount = 0;
        }
        this.discountedPrice = newValue - this.formm.discount
      }, 10);
    },
    handleInputChangeDiscount(field, newValue) {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.timeoutId = setTimeout(() => {
        if (this.currency != '%') {
          if (newValue < 0 || newValue === '') {
            this.formm[field] = 0;
          }
          if (newValue > this.formm.price) {
            this.formm.discount = 0;
          }
          this.discountedPrice = this.formm.price - newValue
        } else {
          if ((newValue < 0 && newValue > 100) || newValue === '') {
            this.formm[field] = 0;
          }
          this.discountedPrice = this.formm.price - (newValue / 100) * this.formm.price
        }
      }, 10);
    },
    handleInputChangePriceDiscount(newValue) {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.timeoutId = setTimeout(() => {
        if (newValue > this.formm.price) {
          this.formm.discount = 0;
          this.discountedPrice = this.formm.price;
        } else if (this.currency != '%') {
          this.formm.discount = this.formm.price - newValue;
        } else {
          this.discountedPrice = this.formm.price - (this.formm.discount / 100) * this.formm.price
        }
      }, 10);
    },
    addNewRowForCD() {
      this.form.push({
        isEditable: true,
        isStockAvailable: true,
        length: 0,
        materialVariantId: null,
        measurementType: 'Meter',
        name: null,
        quantity: 0,
      });
    },
    showMaterialName() {
      this.toggleSearch = 'MaterialName'
    },
    showDescription() {
      this.toggleSearch = 'Description'
    },
    currentStock(value) {
      this.clickedMaterialVariantId = value
      this.currentStockByVariant(value)
    },
    async getAllImages(item) {
      try {
        let materialVariantId = null;
        if (item && item.materialVariantId != null) {
          materialVariantId = item.materialVariantId;
        } else if (item && item.name != null && item.name.materialVariantId != null) {
          materialVariantId = item.name.materialVariantId;
        }
        if (materialVariantId !== null) {
          await this.getImagesByMaterialVariantId(materialVariantId).then((res) => {
            console.log(res);
          });
          this.image.imgs = [];
          for (let i = 0; i < this.getImagesProduct.length; i++) {
            const image = this.getImagesProduct[i];
            this.image.imgs.push({
              src: image.url,
              title: image.fileName,
              materialVariantPhotoId: image.materialVariantPhotoId,
              fileName: image.fileName,
              fileType: image.fileType,
            });
          }
          this.show();
        } else {
          console.log('Material Variant ID is null or undefined.');
        }
      } catch (e) {
        console.log(e);
      }
    },
    show() {
      this.image.visible = true
    },
    handleHide() {
      this.image.visible = false
      this.image.imgs.length = []
    },
    valid(item) {
      if (item < 0.001) {
        this.showLengthError = true;
      } else {
        this.showLengthError = false;
      }
    },
    fillForm() {
      this.form = []
      for (let i = 0; i < this.getEditOrderItemMaterialVariant.length; i++) {
        this.form.push(this.getEditOrderItemMaterialVariant[i])
      }
    },
    removeMaterialItemFromCD(index) {
      this.form.splice(index, 1);
    },
    meter(value) {
      value.name = '';
      value.quantity = 0
      value.length = 0
      this.getMaterialVariantsToMDCPagination({
        pageNumber: 1,
        pageSize: 15,
        measurement: 'Meter',
      })
    },
    resetPackage(value) {
      value.name = '';
      value.quantity = 0
      value.length = 0
      this.getMaterialVariantsToMDCPagination({
        pageNumber: 1,
        pageSize: 15,
        measurement: 'Package',
      })
    },
    resetSet(value) {
      value.name = '';
      value.quantity = 0
      value.length = 0
      this.getMaterialVariantsToMDCPagination({
        pageNumber: 1,
        pageSize: 15,
        measurement: 'Set',
      })
    },
    resetPair(value) {
      value.name = '';
      value.quantity = 0
      value.length = 0
      this.getMaterialVariantsToMDCPagination({
        pageNumber: 1,
        pageSize: 15,
        measurement: 'Pair',
      })
    },
    resetVerse(value) {
      value.name = '';
      value.quantity = 0
      value.length = 0
      this.getMaterialVariantsToMDCPagination({
        pageNumber: 1,
        pageSize: 15,
        measurement: 'Verse',
      })
    },
    part(value) {
      value.name = '';
      value.quantity = 0
      value.length = 0
      this.getMaterialVariantsToMDCPagination({
        pageNumber: 1,
        pageSize: 15,
        measurement: 'Part',
      })
    },
    async onSubmit() {
      if (this.duplicatedMaterials) {
        return;
      }
      if (this.emptyList) {
        return;
      }
      try {
        const materialVariants = []
        // eslint-disable-next-line no-restricted-syntax
        for (const item of this.form) {
          if (typeof item.name === 'object') {
            materialVariants.push({
              name: item.name.materialVariantName, measurementType: item.measurementType, materialVariantId: item.name.materialVariantId, length: item.length, quantity: item.quantity,
            })
          } else {
            materialVariants.push({
              name: item.name, measurementType: item.measurementType, materialVariantId: item.materialVariantId, length: item.length, quantity: item.quantity,
            })
          }
        }
        if (this.showLengthError == true) {
          return;
        }
        if (this.formm.articleNumber == null || this.formm.articleNumber == '') {
          return
        }

        this.formm.materialVariantInStoreResponseDtos = materialVariants

        if (this.currency == '%') {
          this.formm.discount = this.formm.price - this.discountedPrice
        }

        this.$emit('editOrderItemm', this.formm)
        this.onCancel()
      } catch (error) {
        console.log(error)
      }
    },
    removeProbeDate(index) {
      this.dress.probeDates.splice(index, 1);
    },
    addNewDate() {
      this.dress.probeDates.push(
        {
          probeName: `${this.$t('FitDate')} ${this.index += 1}`,
          dateOfProbe: '',
          notes: null,
        },
      );
    },
    // updateSelectedValue() {
    //   this.$emit('selected-value-change', this.idx, this.selectedValue);
    // },
    removeCustomDress(index) {
      this.$emit('sendIndex', index)
    },
    async getMVbyMeter(page, pageS) {
      await this.getMaterialVariantsToMDCPagination({
        pageNumber: page,
        pageSize: pageS,
        measurement: 'Meter',
      });
    },
    async getMVbyPackage(page, pageS) {
      await this.getMaterialVariantsToMDCPagination({
        pageNumber: page,
        pageSize: pageS,
        measurement: 'Package',
      });
    },
    async getMVbySet(page, pageS) {
      await this.getMaterialVariantsToMDCPagination({
        pageNumber: page,
        pageSize: pageS,
        measurement: 'Set',
      });
    },
    async getMVbyVerse(page, pageS) {
      await this.getMaterialVariantsToMDCPagination({
        pageNumber: page,
        pageSize: pageS,
        measurement: 'Verse',
      });
    },
    async getMVbyPair(page, pageS) {
      await this.getMaterialVariantsToMDCPagination({
        pageNumber: page,
        pageSize: pageS,
        measurement: 'Pair',
      });
    },
    async getMVbyPart(page, pageS) {
      await this.getMaterialVariantsToMDCPagination({
        pageNumber: page,
        pageSize: pageS,
        measurement: 'Part',
      });
    },
    nextMeter() {
      if (this.pageM < this.getTotalPagesForMVM && this.selectedMaterialVariant == '') {
        this.pageM += 1;
        this.getMVbyMeter(this.pageM, this.pageSize);
      } else if (this.pageM < this.getTotalPagesForMVM && this.selectedMaterialVariant != '') {
        this.pageM += 1;
        this.filterVariantByColor({
          name: this.selectedMaterialVariant,
          measurementType: 'Meter',
          pageNumber: this.pageM,
          pageSize: 15,
        });
      }
    },
    prevMeter() {
      if (this.pageM > 1 && this.selectedMaterialVariant == '') {
        this.pageM -= 1;
        this.getMVbyMeter(this.pageM, this.pageSize);
      } else if (this.pageM > 1 && this.selectedMaterialVariant != '') {
        this.pageM -= 1;
        this.filterVariantByColor({
          name: this.selectedMaterialVariant,
          measurementType: 'Meter',
          pageNumber: this.pageM,
          pageSize: 15,
        });
      }
    },
    nextPackage() {
      if (this.pagePackage < this.getTotalPagesForMVM && this.selectedMaterialVariantPackage == '') {
        this.pagePackage += 1;
        this.getMVbyPackage(this.pagePackage, this.pageSize);
      } else if (this.pagePackage < this.getTotalPagesForMVM && this.selectedMaterialVariantPackage != '') {
        this.pagePackage += 1;
        this.filterVariantByColor({
          name: this.selectedMaterialVariantPackage,
          measurementType: 'Package',
          pageNumber: this.pagePackage,
          pageSize: 15,
        });
      }
    },
    prevPackage() {
      if (this.pagePackage > 1 && this.selectedMaterialVariantPackage == '') {
        this.pagePackage -= 1;
        this.getMVbyPackage(this.pagePackage, this.pageSize);
      } else if (this.pagePackage > 1 && this.selectedMaterialVariantPackage != '') {
        this.pagePackage -= 1;
        this.filterVariantByColor({
          name: this.selectedMaterialVariantPackage,
          measurementType: 'Package',
          pageNumber: this.pagePackage,
          pageSize: 15,
        });
      }
    },
    nextSet() {
      if (this.pageSet < this.getTotalPagesForMVM && this.selectedMaterialVariantSet == '') {
        this.pageSet += 1;
        this.getMVbySet(this.pageSet, this.pageSize);
      } else if (this.pageSet < this.getTotalPagesForMVM && this.selectedMaterialVariantSet != '') {
        this.pageSet += 1;
        this.filterVariantByColor({
          name: this.selectedMaterialVariantSet,
          measurementType: 'Set',
          pageNumber: this.pageSet,
          pageSize: 15,
        });
      }
    },
    prevSet() {
      if (this.pageSet > 1 && this.selectedMaterialVariantSet == '') {
        this.pageSet -= 1;
        this.getMVbySet(this.pageSet, this.pageSize);
      } else if (this.pageSet > 1 && this.selectedMaterialVariantSet != '') {
        this.pageSet -= 1;
        this.filterVariantByColor({
          name: this.selectedMaterialVariantSet,
          measurementType: 'Set',
          pageNumber: this.pageSet,
          pageSize: 15,
        });
      }
    },
    nextVerse() {
      if (this.pageVerse < this.getTotalPagesForMVM && this.selectedMaterialVariantVerse == '') {
        this.pageVerse += 1;
        this.getMVbyVerse(this.pageVerse, this.pageSize);
      } else if (this.pageVerse < this.getTotalPagesForMVM && this.selectedMaterialVariantVerse != '') {
        this.pageVerse += 1;
        this.filterVariantByColor({
          name: this.selectedMaterialVariantVerse,
          measurementType: 'Verse',
          pageNumber: this.pageVerse,
          pageSize: 15,
        });
      }
    },
    prevVerse() {
      if (this.pageVerse > 1 && this.selectedMaterialVariantVerse == '') {
        this.pageVerse -= 1;
        this.getMVbyVerse(this.pageVerse, this.pageSize);
      } else if (this.pageVerse > 1 && this.selectedMaterialVariantVerse != '') {
        this.pageVerse -= 1;
        this.filterVariantByColor({
          name: this.selectedMaterialVariantVerse,
          measurementType: 'Verse',
          pageNumber: this.pageVerse,
          pageSize: 15,
        });
      }
    },
    nextPair() {
      if (this.pagePair < this.getTotalPagesForMVM && this.selectedMaterialVariantPair == '') {
        this.pagePair += 1;
        this.getMVbyPair(this.pagePair, this.pageSize);
      } else if (this.pagePair < this.getTotalPagesForMVM && this.selectedMaterialVariantPair != '') {
        this.pagePair += 1;
        this.filterVariantByColor({
          name: this.selectedMaterialVariantPair,
          measurementType: 'Pair',
          pageNumber: this.pagePair,
          pageSize: 15,
        });
      }
    },
    prevPair() {
      if (this.pagePair > 1 && this.selectedMaterialVariantPair == '') {
        this.pagePair -= 1;
        this.getMVbyPair(this.pagePair, this.pageSize);
      } else if (this.pagePair > 1 && this.selectedMaterialVariantPair != '') {
        this.pagePair -= 1;
        this.filterVariantByColor({
          name: this.selectedMaterialVariantPair,
          measurementType: 'Pair',
          pageNumber: this.pagePair,
          pageSize: 15,
        });
      }
    },
    nextPart() {
      if (this.pageP < this.getTotalPagesForMVP && this.selectedMaterialVariantPart == '') {
        this.pageP += 1;
        this.getMVbyPart(this.pageP, this.pageSize);
      } else if (this.pageP < this.getTotalPagesForMVP && this.selectedMaterialVariantPart != '') {
        this.pageP += 1;
        this.filterVariantByColor({
          name: this.selectedMaterialVariantPart,
          measurementType: 'Part',
          pageNumber: this.pageP,
          pageSize: 15,
        });
      }
    },
    prevPart() {
      if (this.pageP > 1 && this.selectedMaterialVariantPart == '') {
        this.pageP -= 1;
        this.getMVbyPart(this.pageP, this.pageSize);
      } else if (this.pageP > 1 && this.selectedMaterialVariantPart !== '') {
        this.pageP -= 1;
        this.filterVariantByColor({
          name: this.selectedMaterialVariantPart,
          measurementType: 'Part',
          pageNumber: this.pageP,
          pageSize: 15,
        });
      }
    },
    async onSearchM(query) {
      console.log('query', query)
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.timeoutId = setTimeout(() => {
        if (query === '') {
          this.resetAllFiltered();
          this.getMVbyMeter(this.getCurrentPageForMVM, this.pageSize);
          this.selectedMaterialVariant = ''
          this.pageM = 1
        } else if (this.toggleSearch === 'MaterialName') {
          this.selectedMaterialVariant = query;
          this.filterVariantByColor({
            name: query,
            measurementType: 'Meter',
            pageNumber: this.pageM,
            pageSize: 15,
          });
        }
      }, 500);
    },
    async onSearchMDesc(query) {
      console.log('query', query)
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.timeoutId = setTimeout(() => {
        if (query === '') {
          this.resetAllFiltered();
          this.getMVbyMeter(this.getCurrentPageForMVM, this.pageSize);
          this.selectedMaterialVariant = ''
          this.pageM = 1
        } else if (this.toggleSearch === 'Description') {
          this.selectedMaterialVariant = query;
          this.filterVariantByCode({
            code: query,
            measurementType: 'Meter',
            pageNumber: this.pageM,
            pageSize: 15,
          })
        }
      }, 500);
    },
    async onSearchPack(query) {
      console.log('query', query)
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.timeoutId = setTimeout(() => {
        if (query === '') {
          this.resetAllFiltered();
          this.getMVbyPackage(this.getCurrentPageForMVM, this.pageSize);
          this.selectedMaterialVariantPackage = ''
          this.pageM = 1
        } else if (this.toggleSearch === 'MaterialName') {
          this.selectedMaterialVariantPackage = query;
          this.filterVariantByColor({
            name: query,
            measurementType: 'Package',
            pageNumber: this.pagePackage,
            pageSize: 15,
          });
        }
      }, 500);
    },
    async onSearchPackDesc(query) {
      console.log('query', query)
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.timeoutId = setTimeout(() => {
        if (query === '') {
          this.resetAllFiltered();
          this.getMVbyPackage(this.getCurrentPageForMVM, this.pageSize);
          this.selectedMaterialVariantPackage = ''
          this.pageM = 1
        } else if (this.toggleSearch === 'Description') {
          this.selectedMaterialVariantPackage = query;
          this.filterVariantByCode({
            code: query,
            measurementType: 'Package',
            pageNumber: this.pagePackage,
            pageSize: 15,
          })
        }
      }, 500);
    },
    async onSearchSet(query) {
      console.log('query', query)
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.timeoutId = setTimeout(() => {
        if (query === '') {
          this.resetAllFiltered();
          this.getMaterialsVBySet(this.getCurrentPageForMVM, this.pageSize);
          this.selectedMaterialVariantSet = ''
          this.pageM = 1
        } else if (this.toggleSearch === 'MaterialName') {
          this.selectedMaterialVariantSet = query;
          this.filterVariantByColor({
            name: query,
            measurementType: 'Set',
            pageNumber: this.pageSet,
            pageSize: 15,
          });
        }
      }, 500);
    },
    async onSearchSetDesc(query) {
      console.log('query', query)
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.timeoutId = setTimeout(() => {
        if (query === '') {
          this.resetAllFiltered();
          this.getMaterialsVBySet(this.getCurrentPageForMVM, this.pageSize);
          this.selectedMaterialVariantSet = ''
          this.pageM = 1
        } else if (this.toggleSearch === 'Description') {
          this.selectedMaterialVariantSet = query;
          this.filterVariantByCode({
            code: query,
            measurementType: 'Set',
            pageNumber: this.pageSet,
            pageSize: 15,
          })
        }
      }, 500);
    },
    async onSearchPair(query) {
      console.log('query', query)
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.timeoutId = setTimeout(() => {
        if (query === '') {
          this.resetAllFiltered();
          this.getMaterialsVByPair(this.getCurrentPageForMVM, this.pageSize);
          this.selectedMaterialVariantPair = ''
          this.pageM = 1
        } else if (this.toggleSearch === 'MaterialName') {
          this.selectedMaterialVariantPair = query;
          this.filterVariantByColor({
            name: query,
            measurementType: 'Pair',
            pageNumber: this.pagePair,
            pageSize: 15,
          });
        }
      }, 500);
    },
    async onSearchPairDesc(query) {
      console.log('query', query)
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.timeoutId = setTimeout(() => {
        if (query === '') {
          this.resetAllFiltered();
          this.getMaterialsVByPair(this.getCurrentPageForMVM, this.pageSize);
          this.selectedMaterialVariantPair = ''
          this.pageM = 1
        } else if (this.toggleSearch === 'Description') {
          this.selectedMaterialVariantPair = query;
          this.filterVariantByCode({
            code: query,
            measurementType: 'Pair',
            pageNumber: this.pagePair,
            pageSize: 15,
          })
        }
      }, 500);
    },
    async onSearchVerse(query) {
      console.log('query', query)
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.timeoutId = setTimeout(() => {
        if (query === '') {
          this.resetAllFiltered();
          this.getMaterialsVByVerse(this.getCurrentPageForMVM, this.pageSize);
          this.selectedMaterialVariantVerse = ''
          this.pageM = 1
        } else if (this.toggleSearch === 'MaterialName') {
          this.selectedMaterialVariantVerse = query;
          this.filterVariantByColor({
            name: query,
            measurementType: 'Verse',
            pageNumber: this.pageVerse,
            pageSize: 15,
          });
        }
      }, 500);
    },

    async onSearchVerseDesc(query) {
      console.log('query', query)
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.timeoutId = setTimeout(() => {
        if (query === '') {
          this.resetAllFiltered();
          this.getMaterialsVByVerse(this.getCurrentPageForMVM, this.pageSize);
          this.selectedMaterialVariantVerse = ''
          this.pageM = 1
        } else if (this.toggleSearch === 'Description') {
          this.selectedMaterialVariantVerse = query;
          this.filterVariantByCode({
            code: query,
            measurementType: 'Verse',
            pageNumber: this.pageVerse,
            pageSize: 15,
          })
        }
      }, 500);
    },

    async onSearchP(query) {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.timeoutId = setTimeout(() => {
        if (query === '') {
          this.resetAllFiltered();
          this.getMVbyPart(this.getCurrentPageForMVP, this.pageSize);
          this.selectedMaterialVariantPart = ''
          this.pageP = 1
        } else if (this.toggleSearch === 'MaterialName') {
          this.selectedMaterialVariantPart = query;
          this.filterVariantByColor({
            name: query,
            measurementType: 'Part',
            pageNumber: this.pageP,
            pageSize: 15,
          });
        }
      }, 500);
    },

    async onSearchPDesc(query) {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.timeoutId = setTimeout(() => {
        if (query === '') {
          this.resetAllFiltered();
          this.getMVbyPart(this.getCurrentPageForMVP, this.pageSize);
          this.selectedMaterialVariantPart = ''
          this.pageP = 1
        } else if (this.toggleSearch === 'Description') {
          this.selectedMaterialVariantPart = query;
          this.filterVariantByCode({
            code: query,
            measurementType: 'Part',
            pageNumber: this.pageP,
            pageSize: 15,
          })
        }
      }, 500);
    },
    onCancel() {
      this.$emit('onCancelToggle');
      this.$refs.modal.hide();
      setTimeout(() => { this.$v.$reset() }, 0)
      this.$nextTick(() => { this.$v.$reset() })
      setTimeout(() => {
        // this.resetForm();


      }, 10);
    },
    onReset() {
      this.form = [];
      this.materials = [];
      this.currency = '€';
      this.discountedPrice = 0;
      this.formm = {
        orderItemId: null,
        bodyMeasurements: {
          thorax: null,
          aroundBust: null,
          aroundUnderBust: null,
          waist: null,
          aroundHips: null,
          aroundLeg: null,
          aroundKnee: null,
          aroundNeck: null,
          aroundSleeve: null,
          ankle: null,
          breastReduction: null,
          chestDistance: null,
          interBust: null,
          frontBody: null,
          length1: null,
          length2: null,
          length3: null,
          length4: null,
          elbow: null,
          wrist: null,
          back: null,
          backBody: null,
          shoulders: null,
          declineOfTheHips: null,
          sleeveLength: null,
        },
        discount: 0,
        articleNumber: '',
        size: '',
        pickUpDate: '',
        price: 0,
        paidAmount: 0,
        materialVariantInStoreResponseDtos: [],
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.active2 {
  font-weight: bold;
  color: $base-color;
}
.search-toggle {
  margin: 5px 0px;
}
form {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.hello{
  display: flex;
  justify-content: space-between;
  flex-direction: row;
}

.headline {
  padding: 5px 10px;
  background-color: $base-color;
  color: $digit-white;
  border-radius: 8px;
}

.custom-modal__wrapper {
  display: flex;
  justify-content: space-between;
  border: 1px solid lightgray;
  border-radius: 10px;
  padding: 10px 0px;

  >div {
    flex: 1;
    margin: 0px 15px;
  }
}

.flex-form {
  display: flex;
  flex-direction: column;
}

.fixed-height-modal {
  height: calc(100vh - 160px);
  overflow-y: auto;
  padding-right: 1rem;
}

.customDress-container {
  border: 3px solid lightgray;
  border-radius: 10px;
  padding: 15px;
  margin-top: 20px;
}

.customDress-container:last-child {
  margin-bottom: 20px;
}

.inside-actions {
  margin-left: 8px;
  cursor: pointer;
  border: 1px solid transparent;
  box-shadow: none;
  padding: 2px 4px;
  border-radius: 7px;
}

.inside-actions:hover {
  background-color: #242F6E;
  color: #fff;
}

.f {
  border-color: red !important;
}
.front-body {
  position: relative;
  display: flex;
  justify-content: center;
  gap: 50px;
  padding-bottom: 20px;
  img {
    width: 100%;
  }
  .betweenCol{
    display: flex;
    flex-direction: column;
    gap: 25px;
  }
  .input{
    max-width: 100%;
    height: 51px;
    display: flex;
    flex-direction: column;
    gap: 0px;
  }
  .toraks {
    display: flex;
    position: absolute;
    top: 106px;
    left: 100px;
    max-width: 180px;
    width: 100%;
    height: 25px;
  }
  .rrethiGjoksit {
    display: flex;
    position: absolute;
    top: 135px;
    left: 100px;
    max-width: 180px;
    width: 100%;
    height: 25px;
  }
  .rrethiNenGjoksit {
    display: flex;
    position: absolute;
    top: 165px;
    left: 100px;
    max-width: 180px;
    width: 100%;
    height: 25px;
  }
  .beli {
    display: flex;
    position: absolute;
    top: 200px;
    left: 100px;
    max-width: 180px;
    width: 100%;
    height: 25px;
  }
  .vithet {
    display: flex;
    position: absolute;
    top: 263px;
    right: 110px;
    max-width: 180px;
    width: 100%;
    height: 25px;
  }
  .rrethiKembes {
    display: flex;
    position: absolute;
    bottom: 222px;
    right: 110px;
    max-width: 180px;
    width: 100%;
    height: 25px;
  }
  .rrethiGjurit {
    display: flex;
    position: absolute;
    bottom: 148px;
    right: 110px;
    max-width: 180px;
    width: 100%;
    height: 25px;
  }
  .zoguKembeve {
    display: flex;
    position: absolute;
    bottom: 38px;
    right: 110px;
    max-width: 180px;
    width: 100%;
    height: 25px;
  }
  .reniaGjoksit {
    display: flex;
    position: absolute;
    top: 85px;
    right: 110px;
    max-width: 180px;
    width: 100%;
    height: 25px;
  }
  .nderGjoks {
    display: flex;
    position: absolute;
    top: 158px;
    right: 110px;
    max-width: 180px;
    width: 100%;
    height: 25px;
  }
  .trupiPara {
    display: flex;
    position: absolute;
    top: 200px;
    right: 110px;
    max-width: 180px;
    width: 100%;
    height: 25px;
  }
  .distancaGjoksit {
    display: flex;
    position: absolute;
    top: 128px;
    right: 110px;
    max-width: 180px;
    width: 100%;
    height: 25px;
  }
  .gjatesia1 {
    display: flex;
    position: absolute;
    bottom: 222px;
    left: 100px;
    max-width: 180px;
    width: 100%;
    height: 25px;
  }
  .gjatesia2 {
    display: flex;
    position: absolute;
    bottom: 127px;
    left: 100px;
    max-width: 180px;
    width: 100%;
    height: 25px;
  }
  .gjatesia3 {
    display: flex;
    position: absolute;
    bottom: 68px;
    left: 100px;
    max-width: 180px;
    width: 100%;
    height: 25px;
  }
  .gjatesia4 {
    display: flex;
    position: absolute;
    bottom: 8px;
    left: 100px;
    max-width: 180px;
    width: 100%;
    height: 25px;
  }
}
.btn-con {
  display: flex;
}
.back-body {
  position: relative;
  img {
    width: 100%;
  }
  .rrethiMenges {
    display: flex;
    position: absolute;
    top: 126px;
    right: 110px;
    max-width: 180px;
    width: 100%;
    height: 25px;
  }
  .brryli {
    display: flex;
    position: absolute;
    top: 156px;
    right: 110px;
    max-width: 180px;
    width: 100%;
    height: 25px;
  }
  .kyçi {
    display: flex;
    position: absolute;
    top: 192px;
    left: 100px;
    max-width: 180px;
    width: 100%;
    height: 25px;
  }
  .rrethiQafes {
    display: flex;
    position: absolute;
    top: 60px;
    right: 110px;
    max-width: 180px;
    width: 100%;
    height: 25px;
  }
  .trupiPrapa {
    display: flex;
    position: absolute;
    top: 202px;
    right: 110px;
    max-width: 180px;
    width: 100%;
    height: 25px;
  }
  .supet {
    display: flex;
    position: absolute;
    top: 97px;
    left: 100px;
    max-width: 180px;
    width: 100%;
    height: 25px;
  }
  .shpina {
    display: flex;
    position: absolute;
    top: 135px;
    left: 100px;
    max-width: 180px;
    width: 100%;
    height: 25px;
  }
  .reniaVitheve {
    display: flex;
    position: absolute;
    bottom: 253px;
    right: 110px;
    max-width: 180px;
    width: 100%;
    height: 25px;
  }
  .gjatesiaMenges {
    display: flex;
    position: absolute;
    top: 95px;
    right: 110px;
    max-width: 180px;
    width: 100%;
    height: 25px;
  }
}
@media only screen and (max-width: 1200px){
  .front-body {
  position: relative;
  .toraks {
    top: 65px;
    left: 1px;
    max-width: 150px;
    width: 100%;
    height: 25px;
  }
  .rrethiGjoksit {
    position: absolute;
    top: 95px;
    left: 1px;
    max-width: 150px;
    width: 100%;
    height: 25px;
  }
  .rrethiNenGjoksit {
    position: absolute;
    top: 125px;
    left: 1px;
    max-width: 150px;
    width: 100%;
    height: 25px;
  }
  .beli {
    position: absolute;
    top: 155px;
    left: 1px;
    max-width: 150px;
    width: 100%;
    height: 25px;
  }
  .vithet {
    position: absolute;
    top:249px;
    right: 1px;
    max-width: 150px;
    width: 100%;
    height: 25px;
  }
  .rrethiKembes {
    position: absolute;
    bottom: 65px;
    right: 1px;
    max-width: 150px;
    width: 100%;
    height: 25px;
  }
  .rrethiGjurit {
    position: absolute;
    bottom: 35px;
    right: 1px;
    max-width: 150px;
    width: 100%;
    height: 25px;
  }
  .zoguKembeve {
    position: absolute;
    bottom: 5px;
    right: 1px;
    max-width: 150px;
    width: 100%;
    height: 25px;
  }
  .reniaGjoksit {
    position: absolute;
    top: 65px;
    right: 1px;
    max-width: 150px;
    width: 100%;
    height: 25px;
  }
  .nderGjoks {
    position: absolute;
    top: 125px;
    right: 1px;
    max-width: 150px;
    width: 100%;
    height: 25px;
  }
  .trupiPara {
    position: absolute;
    top: 155px;
    right: 1px;
    max-width: 150px;
    width: 100%;
    height: 25px;
  }
  .distancaGjoksit {
    position: absolute;
    top: 95px;
    right: 1px;
    max-width: 150px;
    width: 100%;
    height: 25px;
  }
  .gjatesia1 {
    position: absolute;
    bottom: 95px;
    left: 1px;
    max-width: 150px;
    width: 100%;
    height: 25px;
  }
  .gjatesia2 {
    position: absolute;
    bottom: 65px;
    left: 1px;
    max-width: 150px;
    width: 100%;
    height: 25px;
  }
  .gjatesia3 {
    position: absolute;
    bottom: 35px;
    left: 1px;
    max-width: 150px;
    width: 100%;
    height: 25px;
  }
  .gjatesia4 {
    position: absolute;
    bottom: 5px;
    left: 1px;
    max-width: 150px;
    width: 100%;
    height: 25px;
  }
}
.btn-con {
  display: flex;
  button {
    border: none;
    background-color: #6c757d;;
    color: $digit-white;
    border-radius: 0.25rem;
    padding: 3px 12px;
  }
}
.back-body {
  position: relative;
  img {
    width: 100%;
  }
  .rrethiMenges {
    position: absolute;
    top: 126px;
    right: 1px;
    max-width: 150px;
    width: 100%;
    height: 25px;
  }
  .brryli {
    position: absolute;
    top: 156px;
    right: 1px;
    max-width: 150px;
    width: 100%;
    height: 25px;
  }
  .kyçi {
    position: absolute;
    top: 192px;
    left: 1px;
    max-width: 150px;
    width: 100%;
    height: 25px;
  }
  .rrethiQafes {
    position: absolute;
    top: 70px;
    right: 1px;
    max-width: 150px;
    width: 100%;
    height: 25px;
  }
  .trupiPrapa {
    position: absolute;
    top: 215px;
    right: 1px;
    max-width: 150px;
    width: 100%;
    height: 25px;
  }
  .supet {
    position: absolute;
    top: 97px;
    left: 1px;
    max-width: 150px;
    width: 100%;
    height: 25px;
  }
  .shpina {
    position: absolute;
    top: 70px;
    left: 1px;
    max-width: 150px;
    width: 100%;
    height: 25px;
  }
  .reniaVitheve {
    position: absolute;
    bottom: 100px;
    right: 1px;
    max-width: 150px;
    width: 100%;
    height: 25px;
  }
  .gjatesiaMenges {
    position: absolute;
    top: 98px;
    right: 1px;
    max-width: 150px;
    width: 100%;
    height: 25px;
  }
}
}
input[type='radio']:checked:after {
        width: 15px;
        height: 15px;
        border-radius: 15px;
        top: -3px;
        left: -1px;
        position: relative;
        background-color: $base-color ;
        content: '';
        display: inline-block;
        visibility: visible;
        border: 2px solid white;
    }
@media only screen and (max-width: 800px) {
  .front-body {
    .vithet {
      position: absolute;
    top: 195px;
    right: 1px;
    max-width: 150px;
    width: 100%;
    height: 25px;
    }
  }
}

</style>
